import { getSpeakerLayoutBorderKey } from '@goldcast/utils';
import { layoutConfigMap } from './layoutConfigMap';
import { LayoutChange } from '../../MainPlayer/types/Segment/LayoutChange';
import { BaseConfig } from '../../MainPlayer/utils/speakerLayoutGenerator/types';
import { isLayoutAudiogram } from '@/libs/layout';

export const getFinalConfigForLayout = (layout: LayoutChange | undefined, videosToShow: string[]): BaseConfig[] => {
  if (!layout) {
    return [];
  }
  if (isLayoutAudiogram(layout.layout)) {
    return [];
  }
  const config =
    layoutConfigMap[layout.size]?.[layout.layout]?.[layout.fitMode]?.[getSpeakerLayoutBorderKey(!layout.hideBorders)]?.[
      videosToShow.length
    ];
  if (config) {
    return config;
  }
  return [
    {
      style: { display: 'none' },
      containerStyle: { display: 'none' }
    }
  ];
};
